import { Component, OnInit, Input } from '@angular/core';
import { TimestampTexts } from '../models/timestamp-texts';

/**
 * Legenda de cores discretas.
 * Pode ser usado para categorias discretas de chuva, ocorrências, câmeras, etc.
 */
@Component({
  selector: 'app-discrete-legend',
  templateUrl: './discrete-legend.component.html',
  styleUrls: ['./discrete-legend.component.css']
})
export class DiscreteLegendComponent implements OnInit {

  /** Linhas de texto do título da legenda. */
  @Input() titleLines: string[] = [];

  /** Valores a serem exibidos na legenda. */
  @Input() values: string[] = [];
  
  /** Cores de cada item da legenda. */
  @Input() colors: string[] = [];

  /** Tooltip para cada item da legenda */
  @Input() tooltips: string[] = [];
  
  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Define o título da legenda e os números exibidos na legenda
   * @param values cada número será exibido com uma cor na legenda.
   */
  insertText(titleLines: string[], timestamp: string, values: number[]) {

    this.titleLines = titleLines;
  }
}
